// @Version: 1.0.2
import {Component, OnDestroy} from "@angular/core";
import {FIXED_VARIANT,  TRANSLATE_PATH} from "../../shared.model";
import {UntilDestroy} from "@ngneat/until-destroy";
import { TranslateDesignPipe } from "../../pipes/translate-design/translate-design.pipe";

@UntilDestroy()
@Component({
   selector: "app-footer",
   templateUrl: "./footer.component.html",
   standalone: false
})
export class FooterComponent implements OnDestroy {

   public TRANSLATE_PATH: typeof TRANSLATE_PATH = TRANSLATE_PATH;

   public isFixed_: boolean = false;
   public fixedVariant_: string = FIXED_VARIANT.DEFAULT;
   public todayTime: Date = new Date();

   ngOnDestroy(): void {
      this.todayTime = new Date();
   }

   public onMouseEnter (hoverName: HTMLElement | null): void {
      if (hoverName == null) return;
      hoverName.classList.add ('mouse-enter');
   }

   public onMouseLeave (hoverName: HTMLElement | null): void {
      if (hoverName == null) return;
      hoverName.classList.remove ('mouse-enter');
   }
}